import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {CompanyHeaderContainerModel} from '../../../../../../models/aggregates/company';
import {Core2Config} from '../../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class CompanyHeaderService extends BaseApiTemplateService<CompanyHeaderContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'companies-hdrs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'companies-hdrs';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'companies-hdrs';
    this.httpClient = http;
  }

}
